<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
            lịch sử trò chuyện</span></h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <!-- <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Mô tả:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input clearable placeholder="Mô tả..." v-model="search.cMoTa" />
              </el-col>
            </el-row>
          </el-col> -->
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-select placeholder="Tất cả" v-model="search.nTrangThai">
                  <el-option label="Tất cả" value="" selected></el-option>
                  <el-option label="Hoạt động" value="1" selected></el-option>
                  <el-option label="Đã kết thúc" value="0" selected></el-option>
                </el-select>
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div class="body-function">
          <div class="col-md-6">
            <!-- <el-button plain type="primary" outline native-type="submit" @click="handleOpenAdd" data-bs-toggle="modal"
              data-bs-target="#modal_news">
              <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
              <span class="btn-inner--text">&nbsp;Thêm lịch sử trò chuyện</span>
            </el-button> -->
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" height="100%" fit
            stripe highlight-current-row>
            <el-table-column prop="id" show-overflow-tooltip class="text-nowrap" label="Mã" width="80"
              align="center">
            </el-table-column>
            <el-table-column prop="cNguoiDung" show-overflow-tooltip class="text-nowrap" label="Người dùng" width="150">
            </el-table-column>
            <el-table-column prop="cNoiDung" show-overflow-tooltip class="text-nowrap" label="Nội dung">
            </el-table-column>
            <el-table-column prop="dNgayTao" label="Ngày tạo" align="center" width="120">
              <template #default="scope">
                {{ momentDate(scope.row.dNgayTao) }}
              </template>
            </el-table-column>
            <el-table-column prop="dNgayCapNhatCuoi" label="Ngày cập nhật cuối" align="center" width="120">
              <template #default="scope">
                {{ momentDate(scope.row.dNgayCapNhatCuoi ? scope.row.dNgayCapNhatCuoi : scope.row.dNgayTao) }}
              </template>
            </el-table-column>
            <el-table-column prop="nTrangThai" label="Trạng thái" width="120" align="center">
              <template #default="scope">
                <el-tag type="success" v-if="scope.row.nTrangThai == 1" size="small">Hoạt động</el-tag>
                <el-tag type="danger" v-if="scope.row.nTrangThai == 0" size="small">Đã kết thúc</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="Hành động" align="center" width="120">
              <template #default="scope">
                <el-button plain type="primary"
                  data-bs-toggle="modal" data-bs-target="#modal_news" @click="handleOpenDetail(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-eye"></i></span>
                </el-button>
                <!-- <el-button plain type="danger" :disabled="scope.row.nTrangThai == 0"
                  v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                </el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
          :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>

    <div class="modal fade" id="modal_news" ref="newsModalRef" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mw-500px">
        <div class="modal-content">
          <!--begin::Modal header-->
          <div class="modal-header" id="modal_news_header">
            <!--begin::Modal title-->
            <h2 class="fw-bolder">{{ "Chi tiết lịch sử trò chuyện" }}</h2>
            <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" @click="handleClose">
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <div class="modal-body mh-450px overflow-scroll">
            <div class="history-screen" v-if="formData.lichSu && formData.lichSu.length > 0">
              <div class="message" v-for="item in formData.lichSu">
                <div v-if="item.role == 'user'">
                  <div class="message-user">
                    <div class="message-user-name">Người dùng</div>
                    <div class="message-user-content" v-html="item.content"></div>
                  </div>
                </div>
                <div v-else-if="item.role == 'assistant'">
                  <div class="message-assistant">
                    <div class="message-assistant-name">Trợ lý</div>
                    <div class="message-assistant-content" v-html="item.content"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="btn-group">
              <el-button plain type="danger" @click="handleClose">Thoát</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-model="dialogVisible" class="bg-transparent w-auto shadow-none">
      <img class="mh-500px mw-1000px" :src="dialogImageUrl" alt="Preview Image" />
    </el-dialog>
  </div>
</template>
<script>
import { ChatHistory } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import ImageResize from "quill-image-resize";
import { baseUrl } from "@/utils/global";
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { ElMessage } from "element-plus";


export default {
  name: 'ChatHistory',

  data() {
    return {
      search: {
        cTieuDe: "",
        nTrangThai: null,
      },
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      formData: {
        id: null,
        cTieuDe: "",
        cNoiDung: "",
        nTrangThai: 1,
      },
      rules: {
        cTieuDe: [{ required: true, message: "Xin vui lòng điền Tiêu đề", trigger: "blur" }],
        cNoiDung: [{ required: true, message: "Xin vui lòng điền Nội dung", trigger: "blur" }],
      },
      tableData: {
        content: [{}]
      },
      isLoading: false,
      modalVisible: false,
      iframeURL: "",
      openIframe: false,
      isSearchLoading: false,
      store: useStore(),
      dialogImageUrl: null,
      dialogVisible: false,
    }
  },
  methods: {
    handleChangePageNum(val) {
      this.pageRequest.pageNum = val
      this.handleFindPage()
    },
    handleChangePageSize(val) {
      this.pageRequest.pageSize = val
      this.handleFindPage()
    },
    handleOpenDetail(val) {
      this.modalVisible = true
      this.formData = Object.assign({}, val)
    },
    handleClose() {
      this.modalVisible = false
      hideModal(this.$refs.newsModalRef)
    },
    handleDelete(val) {
      this.$confirm("Bạn có muốn xóa lịch sử trò chuyện này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.store.dispatch(ChatHistory.deleteChatHistory, val.id).then(res => {
            if (res.code == 200) {
              ElMessage({ message: "Xóa lịch sử trò chuyện thành công", type: "success" });
              this.handleFindPage()
            } else {
              ElMessage({ message: res.msg, type: "error" });
            }
          }).catch((error) => {
            ElMessage({ message: "Xóa lịch sử trò chuyện thất bại", type: "error" });
          })
        }).catch(() => {

        })
    },
    handleFindPage() {
      this.pageRequest.columnFilters = {
        cTieuDe: { value: this.search.cTieuDe },
        nTrangThai: { value: this.search.nTrangThai },
      }
      this.store.dispatch(ChatHistory.findPageChatHistory, this.pageRequest).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
          this.tableData.content.forEach((item) => {
            item.lichSu =JSON.parse(item.cNoiDung)
          })

        }
      }).catch((error) => {
        ElMessage({ message: "Tìm lịch sử thất bại", type: "error" });
      })
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    },
  },
  mounted() {
    this.handleFindPage()
  }
};
</script>
<style lang="scss" scoped>
.form-footnote{
  font-size: 1rem;
  color: #4d52579c;
}

.history-screen {
  display: flex;
  flex-direction: column;
  gap: 10px;  
  overflow-y: auto;
}

.message {
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-radius: 8px;
}

.message-user {
  text-align: right;
  background-color: #e0f7fa;
  border-radius: 8px;
  padding: 10px;
}
.message-user-name {
  font-weight: bold;
  color: #00796b;
}
.message-user-content {
  color: #004d40;
  font-size: 1rem;
}

.message-assistant{
  background-color: #ffe0b2;
  border-radius: 8px;
  padding: 10px;
}
.message-assistant-name{
  font-weight: bold;
  color: #e65100;
}
.message-assistant-content{
  color: #bf360c;
  font-size: 1rem;
}

</style>